import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import ErrorPage from "../components/ErrorPage";
import LandingPage from "../components/LandingPage/LandingPage";
import AnalyticsPage from "../components/AnalyticsPage/AnalyticsPage";
import { PowerBiReports } from "../components/Reports/PowerBiReports";
import RuleLevel from "../components/Reports/RuleLevel";
import MaterialLevel from "../components/Reports/MaterialLevel";
import IBPLandingPage from "../components/Reports/IBPLandingPage";
import IBPHomePage from "../components/Reports/IBPHomePage";
import AccessRequestForm from "../components/UserAccessManagement/AccessRequestForm";
import TrackAccessRequest from "../components/UserAccessManagement/TrackAccessRequest";
import UserAccessReport from "../components/UserAccessManagement/Report/UserAccessReport";
import RequestApprovalDelegation from "../components/UserAccessManagement/RequestApprovalDelegation";
import TicketSummary from "../components/UserAccessManagement/TicketSummary";
import AdminPortal from "../components/UserAccessManagement/AdminPortal";
import AccessControl from '../components/UserAccessManagement/AccessControl';
import {
    landingCardsLoader,
    ioCardsLoader,
    supplyPlanningMenuLoader,
} from "../constants/appLoaders";

import AuthGuard from "./AuthGuard";

const appRouter = createBrowserRouter([
    {
        path: "/",
        element: <AuthGuard />,
        errorElement: <ErrorPage />,
        children: [
            {
                element: <App />,
                children: [
                    {
                        index: true,
                        loader: landingCardsLoader,
                        element: <LandingPage />,
                    },

                    {
                        path: "supply-planning",
                        element: <PowerBiReports />,
                        loader: supplyPlanningMenuLoader,
                        children: [
                            { index: true, element: <RuleLevel /> },
                            { path: "ruleLevel", element: <RuleLevel /> },
                            { path: "materialLevel", element: <MaterialLevel /> },
                            { path: "IBPLandingPage", element: <IBPLandingPage /> },
                            { path: "IBPHomePage", element: <IBPHomePage /> },
                        ],
                    },

                    {
                        path: "inventory-optimization",
                        index: true,
                        loader: ioCardsLoader,
                        element: <LandingPage />,
                    },

                    {
                        path: "kpi-metrics",
                        element: <AnalyticsPage />,
                    },

                    {
                        path: "user-roles/new-request",
                        element: <AccessRequestForm />,
                    },
                    {
                        path: "user-roles/track-access-request",
                        element: <TrackAccessRequest />,
                    },
                    {
                        path: "user-roles/reports",
                        element: <UserAccessReport />,
                    },
                    {
                        path: "user-roles/approval-rights",
                        element: <RequestApprovalDelegation />,
                    },
                    {
                        path: "user-roles/ticket-summary",
                        element: <TicketSummary />,
                    },
                    {
                        path: "user-roles/admin-portal",
                        element: <AdminPortal />,
                    },
                    {
                        path : "user-roles/access-control",
                        element : <AccessControl />
                    }
                ],
            },
        ],
    },
]);

export default appRouter;